import React, {Component} from 'react';
import BarChart from '../BarChart';
import TimeLine from '../TimeLine';
import axios from 'axios';
import moment from 'moment';
import './DistanceReport.css';
import {API_HOST} from '../../../../../constants/constants';
import IButton from '../IButton';
import upArrow from '../../../../../assets/svg/up_arrow_aggrep.svg';
import downArrow from '../../../../../assets/svg/down_arrow_aggrep.svg';
import carSvg from '../../../../../assets/svg/car.svg';
import * as FileSaver from 'file-saver';
import * as XLSX from 'sheetjs-style';

class DistanceReport extends Component{

    constructor(props){
        super(props);

        this.state={
            selectedTime: moment().subtract(1, 'months').startOf('month').valueOf(),
            prevTime: moment().subtract(2, 'months').startOf('month').valueOf(),
            nextTime: moment().startOf('month').valueOf(),
            aggregatedData: {},
            entireFleetChartData: [],
            avgDistancePerModalInMonthChartData: [],
            avgDistanceOfSelectedModel: [],
            selectedGroup: props.selectedGroup,
            selectedDistanceType: 'total_distance',
            isDownloadingReport: false,
            busy: false,
        }

        this.updateSelectedTime = this.updateSelectedTime.bind(this);
        this.buildAvgDistanceOfSelectedModel = this.buildAvgDistanceOfSelectedModel.bind(this);
    }

    componentDidMount() {
        window.$('.rw-container').css('top', '53px');
        this.fetchAvgDistance();
    }

    componentWillUnmount() {
        // window.$('.rw-container').css('top', null);
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    componentDidUpdate(prevProps) {
        if(this.props.selectedGroup && (this.props.selectedGroup !== prevProps.selectedGroup)){
            this.setState({
                selectedGroup: this.props.selectedGroup
            }, function(){
                this.fetchAvgDistance();
            })
        }
    }

    updateSelectedTime(time){
        let epoch = parseInt(time)
        let prevTime = moment(epoch).subtract(1, 'months').startOf('month').valueOf();
        let nextTime = moment(epoch).add(1, 'months').startOf('month').valueOf();
        this.setState({selectedTime: epoch, prevTime: prevTime, nextTime:nextTime}, function(){
            this.fetchAvgDistance();
        });
    }

    convertDigitToShort (value) {
        let val = parseFloat(value);
        if(val && val > 0){
            if(val >= 10000){
                var suffixes = ["", "K", "M", "B","T"];
                var suffixNum = Math.floor((""+val).length/3);
                var shortValue = parseFloat((suffixNum != 0 ? (val / Math.pow(1000,suffixNum)) : val).toPrecision(2));
                if(shortValue < 1){
                    suffixNum = suffixNum-1
                    shortValue = parseFloat((suffixNum != 0 ? (val / Math.pow(1000,suffixNum)) : val));
                }
                if (shortValue % 1 != 0) {
                    if(suffixNum === 1){
                        shortValue = shortValue.toFixed(0);
                    } else {
                        shortValue = shortValue.toFixed(1);
                    }
                    
                }
                return shortValue+suffixes[suffixNum];
            }
            else{
                return this.intToReadableFormat(val);
            }
            
        } else{
            return 0
        }
    }

    intToReadableFormat(num){
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    downloadXLSXFile(monthlyReportDataObj) {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const fileName = "Fleet Insights "+moment(this.state.selectedTime).format("MMMM")+" "+moment(this.state.selectedTime).format("YYYY");
        const monthlyReportData = monthlyReportDataObj;

        const insightsData = this.generateInsightsDataForExcel();

        const monthlyReportWs = XLSX.utils.json_to_sheet(monthlyReportData);
        const insightsWs = XLSX.utils.aoa_to_sheet(insightsData);

        let monthlyReportCols = [
            {wpx:150},
            {wpx:150},
            {wpx:100},
            {wpx:100},
            {wpx:100},
            {wpx:100},
            {wpx:100},
            {wpx:100}
        ];
        monthlyReportWs['!cols'] = monthlyReportCols;

        monthlyReportWs['A1'].s = monthlyReportWs['B1'].s = monthlyReportWs['C1'].s = monthlyReportWs['D1'].s = monthlyReportWs['E1'].s = monthlyReportWs['F1'].s = monthlyReportWs['G1'].s = monthlyReportWs['H1'].s = {
            font: {
                sz: 16,
                bold: true,
                color: { rgb: "FFBE284C" }
            }
        }
        monthlyReportWs['C1'].v = monthlyReportWs['C1'].v +"( km )"
        monthlyReportWs['D1'].v = monthlyReportWs['D1'].v +"( km )"
        monthlyReportWs['E1'].v = monthlyReportWs['E1'].v +"( km )"
        monthlyReportWs['F1'].v = monthlyReportWs['F1'].v +"( km )"
        monthlyReportWs['G1'].v = monthlyReportWs['G1'].v +"( km )"
        monthlyReportWs['H1'].v = monthlyReportWs['H1'].v +"( km )"

        let insightsCols = [
            {wpx:215},
            {wpx:180},
            {wpx:180}
        ];
        insightsWs['!cols'] = insightsCols;

        let insightsRange = XLSX.utils.decode_range(insightsWs['!ref']);

        for(var R = insightsRange.s.r; R <= insightsRange.e.r; ++R) {
            for(var C = insightsRange.s.c; C <= insightsRange.e.c; ++C) {
                var cell_address = {c:C, r:R};
                var cell_ref = XLSX.utils.encode_cell(cell_address);
                if(insightsWs[cell_ref]){

                    if(cell_ref.match("C")){
                        insightsWs[cell_ref].s = {
                            alignment: {
                                horizontal: "right",
                                wrapText: true
                            }
                        }
                    } else {
                        insightsWs[cell_ref].s = {
                            alignment: {
                                horizontal: "left",
                                wrapText: true
                            }
                        }

                        if(cell_ref.match("A")){
                            let headerText = ['Total Km Travelled/Model', 'Avg Km Travelled/Models', 'Top Vehicles (Km Travelled)']
                            if(headerText.includes(insightsWs[cell_ref].v)){
                                insightsWs[cell_ref].s = {
                                    font: {
                                        sz: 18,
                                        bold: true,
                                        color: { rgb: "FFBE284C" }
                                    }
                                }
                            }

                        }
                    }

                    let tableTitle = ['#', 'Model Name', 'Total Kms Travelled', 'Avg Km Per month', 'Vehicle No.', 'Daily Km Travelled', 'Weekly Km Travelled', 'Monthly Km Travelled']
                    if(tableTitle.includes(insightsWs[cell_ref].v)){
                        insightsWs[cell_ref].s = {
                            font: {
                                sz: 16,
                                bold: true,
                                color: { rgb: "FFBE284C" }
                            }
                        }
                    }

                }
            }
          }

        const wb = { 
                        Sheets: { 'Monthly Report': monthlyReportWs, 'Insights': insightsWs }, 
                        SheetNames: ['Monthly Report', 'Insights'] 
                    };

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
        this.setState({isDownloadingReport: false});
    }

    generateInsightsDataForExcel(){
        let data = [];
        data.push(["", "Total Kms travelled", this.state.selectedAggregatedData.totaldistance]);
        data.push(["", "% change in Kms travelled from previous month", this.state.selectedAggregatedData.diff]);
        data.push(["", "No. Of vehicles travelled more than 100 kms in this month", this.state.selectedAggregatedData.totalcount]);
        data.push(["", "% change in no. of vehicles traveling more than 100 kms from previous month", this.state.selectedAggregatedData.totalcountdiff]);
        data.push([" "]);

        data.push(["Total Km Travelled/Model"]);
        data.push(["#","Model Name", "Total Kms Travelled"]);

        for(let i in this.state.selectedAggregatedData['total_distance']){
            let arrObj = [parseInt(i)+1,this.state.selectedAggregatedData['total_distance'][i].model, this.state.selectedAggregatedData['total_distance'][i].totaldistance]
            data.push(arrObj);
        }

        data.push([" "]);
        data.push(["Avg Km Travelled/Models", " "]);
        data.push(["#", "Model Name", "Avg Km Per month"]);

        for(let i in this.state.selectedAggregatedData['avg_distance']){
            let arrObj = [parseInt(i)+1, this.state.selectedAggregatedData['avg_distance'][i].model, this.state.selectedAggregatedData['avg_distance'][i].avgdistance]
            data.push(arrObj);
        }

        data.push([" "]);
        data.push(["Top Vehicles (Km Travelled)", " "]);
        data.push(["#", "Vehicle No.", "Daily Km Travelled"]);

        for(let i in this.state.selectedAggregatedData['top_day']){
            let arrObj = [parseInt(i)+1, this.state.selectedAggregatedData['top_day'][i].vehicleno, this.state.selectedAggregatedData['top_day'][i].totaldistance]
            data.push(arrObj);
        }

        data.push([" "]);
        data.push(["#", "Vehicle No.", "Weekly Km Travelled"]);

        for(let i in this.state.selectedAggregatedData['top_week']){
            let arrObj = [parseInt(i)+1, this.state.selectedAggregatedData['top_week'][i].vehicleno, this.state.selectedAggregatedData['top_week'][i].totaldistance]
            data.push(arrObj);
        }

        data.push([" "]);
        data.push(["#", "Vehicle No.", "Monthly Km Travelled"]);

        for(let i in this.state.selectedAggregatedData['top_month']){
            let arrObj = [parseInt(i)+1, this.state.selectedAggregatedData['top_month'][i].vehicleno, this.state.selectedAggregatedData['top_month'][i].totaldistance]
            data.push(arrObj);
        }

        return data;

    }

    fetchMonthlyReportAndDownloadExcelData(){
        let parentThis = this;
        const auth = window.getAuth();
        this.setState({isDownloadingReport: true});

        if(this.state.selectedGroup){
            let body = {
                "token" : auth.token,
                "selectedtime" : moment.utc(this.state.selectedTime).add(5, 'h').add(30, 'm').valueOf(),
                "groupid" : this.state.selectedGroup
            }
            if(window.showNoGpsFixData === true){
                body.fixqfilter = false
            }
            axios.post(`https://apiplatform.intellicar.in/api/aggreport/getaggreportdownload`, body)
            // axios.post(`${process.env.REACT_APP_REMOTE_HOST}/api/aggreport/getaggreportdownload`, body)
            .then(function (response) {
                parentThis.downloadXLSXFile(response.data.data);
            })
            .catch(function (error) {
                parentThis.setState({isDownloadingReport: false})
            });
        }
    }
    

    fetchAvgDistance(){
        this.setState({busy:true})
        let parentThis = this;
        const auth = window.getAuth();

        if(this.state.selectedGroup){
            let body = {
                "token" : auth.token,
                "selectedtime" : moment.utc(this.state.selectedTime).add(5, 'h').add(30, 'm').valueOf(),
                "groupid" : this.state.selectedGroup
            }
            if(window.showNoGpsFixData === true){
                body.fixqfilter = false
            }
            
            axios.post(`https://apiplatform.intellicar.in/api/aggreport/getaggreport`, body)
            // axios.post(`${process.env.REACT_APP_REMOTE_HOST}/api/aggreport/getaggreport`, body)
                .then(function (response) {
                    parentThis.setState({busy:false})
                    parentThis.setState(
                        {
                            aggregatedData:response.data.data,
                            selectedAggregatedData: response.data.data[parentThis.state.selectedTime],
                            prevAggregatedData: response.data.data[moment(parentThis.state.selectedTime).subtract(1, 'month').startOf('month').valueOf()],
                            nextAggregatedData: response.data.data[moment(parentThis.state.selectedTime).add(1, 'month').startOf('month').valueOf()]
                        }, function(){

                            parentThis.setState({
                                selectedTopModels: parentThis.state.selectedAggregatedData[this.state.selectedDistanceType],
                                prevTopModels: parentThis.state.prevAggregatedData ? parentThis.state.prevAggregatedData[this.state.selectedDistanceType] :  {},
                                nextTopModels: parentThis.state.nextAggregatedData ? parentThis.state.nextAggregatedData[this.state.selectedDistanceType] : {},
                                selectedTopDay: parentThis.state.selectedAggregatedData.top_day,
                                selectedTopWeek: parentThis.state.selectedAggregatedData.top_week,
                                selectedTopMonth: parentThis.state.selectedAggregatedData.top_month,
                                selectedModel: parentThis.state.selectedAggregatedData[this.state.selectedDistanceType][0] && parentThis.state.selectedAggregatedData[this.state.selectedDistanceType][0].model
                            });
                            // entireFleetChartData
                            parentThis.buildEntireFleetChartData();
                            parentThis.buildAvgDistancePerModelInMonth();
                            parentThis.buildAvgDistanceOfSelectedModel(parentThis.state.selectedAggregatedData[this.state.selectedDistanceType][0] && parentThis.state.selectedAggregatedData[this.state.selectedDistanceType][0].model);
                            
                        }
                    )
                })
                .catch(function (error) {
                    parentThis.setState({busy:false,nodata: true})
                    console.log(error);
                });
        }
    }

    buildAvgDistanceOfSelectedModel(model, buildModelGraph = false){
        let selectedModel = model;
        let timeline = Object.keys(this.state.aggregatedData)
        let avgDistanceOfSelectedModel = timeline.map((time) => {
            let obj = {};
            obj.xData = time;
            this.state.aggregatedData[time][this.state.selectedDistanceType].map((model) => {
                if(model.model === selectedModel){
                    obj.yData = this.state.selectedDistanceType === 'total_distance' ? model.totaldistance : model.avgdistance;
                }
            });

            if(!obj.yData){
                obj.yData = 0;
            }
            return obj;
        });

        this.setState({
            avgDistanceOfSelectedModel: avgDistanceOfSelectedModel,
            selectedModel: selectedModel
        });

        if(buildModelGraph){
            let avgDistancePerModalInMonthChartData = this.state.avgDistancePerModalInMonthChartData;
            avgDistancePerModalInMonthChartData.pop();
            let obj = {}
            obj.xData = model;

            for(let i in this.state.selectedAggregatedData[this.state.selectedDistanceType]){

                if(this.state.selectedAggregatedData[this.state.selectedDistanceType][i].model === model){
                    obj.yData = this.state.selectedDistanceType === 'total_distance' ? this.state.selectedAggregatedData[this.state.selectedDistanceType][i].totaldistance : this.state.selectedAggregatedData[this.state.selectedDistanceType][i].avgdistance;
                    break;
                }
            }

            avgDistancePerModalInMonthChartData.push(obj);

            this.setState({
                avgDistancePerModalInMonthChartData: avgDistancePerModalInMonthChartData
            });

        }
    }

    buildEntireFleetChartData(){
        let timeline = Object.keys(this.state.aggregatedData)

        let entireFleetChartData = timeline.map((time) => {
            let obj = {}
            obj.xData = time;
            obj.yData = this.state.aggregatedData[time].totaldistance
            return obj;
        });

        this.setState({entireFleetChartData: entireFleetChartData});
    }

    buildAvgDistancePerModelInMonth(){
        let avgDistancePerModalInMonthChartData = this.state.selectedAggregatedData[this.state.selectedDistanceType].slice(0,12).map((model) => {
            let obj = {}
            obj.xData = model.model;
            obj.yData = this.state.selectedDistanceType === 'total_distance' ? model.totaldistance : model.avgdistance;
            return obj;
        });

        this.setState({avgDistancePerModalInMonthChartData: avgDistancePerModalInMonthChartData});
    }

    selectDistanceType(type) {
        this.setState({
            selectedDistanceType: type,
            selectedTopModels: this.state.selectedAggregatedData[type],
            prevTopModels: this.state.prevAggregatedData[type],
            nextTopModels: this.state.nextAggregatedData?this.state.nextAggregatedData[type]:[],
        }, function(){
            this.buildAvgDistanceOfSelectedModel(this.state.selectedAggregatedData[type][0].model);
            this.buildAvgDistancePerModelInMonth();
        });
    }

    renderMonthsContainer(){
        return(
            <div className="months-container">
                <div>{moment(this.state.prevTime).format('MMM')}</div>
                <div>{moment(this.state.selectedTime).format('MMM')}</div>
                <div>{moment(this.state.nextTime).format('MMM')}</div>
            </div>
        );
    }

    renderRowCount(type, index) {
        if(type === 'prev' || type === 'day'){
            return (
                <div className="rowCount">{index+1}</div>
            )
        }

        return null;
    }

    renderTopModel(type){
        
        let dataArr = []
        // let dataObj = {}
        if(type === 'prev'){
            dataArr = this.state.prevTopModels || [];
            // dataObj = this.state.prevAggregatedData || {};
        }
        else if(type === 'next'){
            dataArr = this.state.nextTopModels || [];
            // dataObj = this.state.nextAggregatedData || {};
        }
        else if(type === 'selected'){
            dataArr = this.state.selectedTopModels || [];
            // dataObj = this.state.selectedAggregatedData || {};
        }

        if(dataArr.length > 0){
            return dataArr.map((model, index) => {
                return(
                    <div key={"topmodel-"+index+type} className="greyed-container" >
                        {this.renderRowCount(type, index)}
                        <div className="greyed-box">
                            <div className="head">
                                <div onClick={() => this.buildAvgDistanceOfSelectedModel(model.model, index > 10)} className="cursorPointer">{model.model}</div>
                                <div className="incDecCount">
                                    <span className={model && this.isNumberNegative(model.diff) ? 'isDrop' : ''}>{model.diff}</span>
                                    <span>
                                        <img src={model && this.isNumberNegative(model.diff) ? downArrow : upArrow} />
                                    </span>
                                </div>
                            </div>
                            <div className="body" title={model && this.intToReadableFormat(model.totaldistance.toFixed(0))}>
                                {this.convertDigitToShort(model && model.totaldistance.toFixed(0))}
                            </div>
                            <div className="foot">
                                <div className="footData">{this.intToReadableFormat(model.count)}</div>
                                <div className="footData" title={model && this.intToReadableFormat(model.avgdistance.toFixed(0))}>{this.convertDigitToShort(model.avgdistance.toFixed(0))}</div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
    }

    isNumberNegative(txt){
        if(txt){
            let val = parseFloat(txt.split('%')[0]);
            if(val < 0){
                return true;
            }
        }
        
        return false;
    }

    renderTopVehicles(type){
        
        let dataArr = []
        // let dataObj = {}
        if(type === 'day'){
            dataArr = this.state.selectedTopDay || [];
            // dataObj = this.state.prevAggregatedData || {};
        }
        else if(type === 'week'){
            dataArr = this.state.selectedTopWeek || [];
            // dataObj = this.state.nextAggregatedData || {};
        }
        else if(type === 'month'){
            dataArr = this.state.selectedTopMonth || [];
            // dataObj = this.state.selectedAggregatedData || {};
        }

        if(dataArr.length > 0){
            return dataArr.map((model, index) => {
                return(
                    <div key={"topvehicle-"+index+type} className="greyed-container">
                        {this.renderRowCount(type, index)}
                        <div className="greyed-box">
                            <div className="head">
                                <div>{model.vehiclemodel}</div>
                                <div>{model.vehicleno}</div>
                            </div>
                            <div className="body">
                                {this.intToReadableFormat(model.totaldistance.toFixed(0))}
                            </div>
                            <div className="foot">
                                <div className="footData"></div>
                                <div className="footData">{model.exactstarttime}</div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
    }

    renderLoader() {
        if(this.state.isDownloadingReport){
            return(
                <div className="arLoader">
                    Downloading Report...
                </div>
            )
        }
        
    }

    render(){
        return(
            <div className='distanceReport'>
                <div className='downloadReportContainer'>
                    <button onClick={(e) => this.fetchMonthlyReportAndDownloadExcelData()}>Download Insights</button>
                </div>
                <div className="body">
                    <div className="left">
                        <div className="equi-blocks">
                            <TimeLine selectedAsOnCount = {(this.state.selectedAggregatedData && this.state.selectedAggregatedData.day_count) ? this.state.selectedAggregatedData.day_count : ''} nextAsOnCount = {(this.state.nextAggregatedData && this.state.nextAggregatedData.day_count) ? this.state.nextAggregatedData.day_count : ''} selectedTime = {this.state.selectedTime} prevTime = {this.state.prevTime} nextTime = {this.state.nextTime} updateSelectedTime={this.updateSelectedTime} />
                            <div className="entire-fleet-block bordered-block">
                                <div className="title">
                                    <span>
                                        Entire fleet : km Travelled
                                        <IButton imgContent="entirefleet.jpg" />
                                    </span>
                                    
                                </div>
                                <div className="count-block">
                                    <div className="count-individual">
                                        <div className="count-details">
                                            <div className="count" title={this.state.prevAggregatedData && this.state.prevAggregatedData.totaldistance && this.intToReadableFormat(this.state.prevAggregatedData.totaldistance.toFixed(0))}>{this.state.prevAggregatedData && this.state.prevAggregatedData.totaldistance ? this.convertDigitToShort(this.state.prevAggregatedData.totaldistance.toFixed(1)) : 0}</div>
                                            <div className="count-change">
                                                <span className={this.state.prevAggregatedData && this.isNumberNegative(this.state.prevAggregatedData.diff) ? 'isDrop' : ''}>{this.state.prevAggregatedData ? (this.state.prevAggregatedData.diff) : 0}</span>
                                                <span>
                                                    <img src={this.state.prevAggregatedData && this.isNumberNegative(this.state.prevAggregatedData.diff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="vehicle-details">
                                            <div className="count-tag">
                                                <img src={carSvg} />
                                                <span>{this.state.prevAggregatedData ? this.intToReadableFormat(this.state.prevAggregatedData.totalcount) : 0}</span>
                                            </div>
                                            <div className="vehicle-count-change">
                                                <span className={this.state.prevAggregatedData && this.isNumberNegative(this.state.prevAggregatedData.totalcountdiff) ? 'isDrop' : ''}>{this.state.prevAggregatedData ? (this.state.prevAggregatedData.totalcountdiff) : 0}</span>
                                                <span>
                                                    <img src={this.state.prevAggregatedData && this.isNumberNegative(this.state.prevAggregatedData.totalcountdiff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="count-individual">
                                        <div className="count-details">
                                            <div className="count" title={this.state.selectedAggregatedData && this.state.selectedAggregatedData.totaldistance && this.intToReadableFormat(this.state.selectedAggregatedData.totaldistance.toFixed(0))}>{this.state.selectedAggregatedData && this.state.selectedAggregatedData.totaldistance ? this.convertDigitToShort(this.state.selectedAggregatedData.totaldistance.toFixed(1)) : 0}</div>
                                            <div className="count-change">
                                                <span className={this.state.selectedAggregatedData && this.isNumberNegative(this.state.selectedAggregatedData.diff) ? 'isDrop' : ''}>{this.state.selectedAggregatedData ? (this.state.selectedAggregatedData.diff) : 0}</span>
                                                <span>
                                                    <img src={this.state.selectedAggregatedData && this.isNumberNegative(this.state.selectedAggregatedData.diff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="vehicle-details">
                                            <div className="count-tag">
                                                <img src={carSvg} />
                                                <span>{this.state.selectedAggregatedData ? this.intToReadableFormat(this.state.selectedAggregatedData.totalcount) : 0}</span>
                                            </div>
                                            <div className="vehicle-count-change">
                                                <span className={this.state.selectedAggregatedData && this.isNumberNegative(this.state.selectedAggregatedData.totalcountdiff) ? 'isDrop' : ''}>{this.state.selectedAggregatedData ? (this.state.selectedAggregatedData.totalcountdiff) : 0}</span>
                                                <span>
                                                    <img src={this.state.selectedAggregatedData && this.isNumberNegative(this.state.selectedAggregatedData.totalcountdiff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="count-individual">
                                        <div className="count-details">
                                            <div className="count" title={this.state.nextAggregatedData && this.state.nextAggregatedData.totaldistance && this.intToReadableFormat(this.state.nextAggregatedData.totaldistance.toFixed(0))}>{this.state.nextAggregatedData && this.state.nextAggregatedData.totaldistance ? this.convertDigitToShort(this.state.nextAggregatedData.totaldistance.toFixed(1)) : 0}</div>
                                            <div className="count-change">
                                                <span className={this.state.nextAggregatedData && this.isNumberNegative(this.state.nextAggregatedData.diff) ? 'isDrop' : ''} >{this.state.nextAggregatedData ? (this.state.nextAggregatedData.diff) : 0}</span>
                                                <span>
                                                    <img src={this.state.nextAggregatedData && this.isNumberNegative(this.state.nextAggregatedData.diff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="vehicle-details">
                                            <div className="count-tag">
                                                <img src={carSvg} />
                                                <span>{this.state.nextAggregatedData ? this.intToReadableFormat(this.state.nextAggregatedData.totalcount) : 0}</span>
                                            </div>
                                            <div className="vehicle-count-change">
                                                <span className={this.state.nextAggregatedData && this.isNumberNegative(this.state.nextAggregatedData.totalcountdiff) ? 'isDrop' : ''}>{this.state.nextAggregatedData ? (this.state.nextAggregatedData.totalcountdiff) : 0}</span>
                                                <span>
                                                    <img src={this.state.nextAggregatedData && this.isNumberNegative(this.state.nextAggregatedData.totalcountdiff) ? downArrow : upArrow} />
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <div className="equi-blocks bordered-block">
                            <div className="title">
                                <span>
                                    Top models : {(this.state.selectedDistanceType).split("_")[0]} km Travelled
                                    <IButton imgContent="totaldistance.jpg" />
                                </span>
                                
                                <div className="selectTab">
                                    <div onClick={() => {this.selectDistanceType('total_distance')}} className={"tab2 "+(this.state.selectedDistanceType === 'total_distance' ? 'active' : '')}>Total</div>
                                    <div onClick={() => {this.selectDistanceType('avg_distance')}} className={"tab1 "+(this.state.selectedDistanceType === 'avg_distance' ? 'active' : '')} >Avg</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    
                                </div>
                                
                            </div>
                            {this.renderMonthsContainer()}
                            <div className="analytics-container overflow">
                                <div className="prevContainer">
                                    {this.renderTopModel('prev')}
                                    
                                </div>
                                <div className="currentContainer">
                                {this.renderTopModel('selected')}
                                </div>
                                <div className="nextContainer">
                                {this.renderTopModel('next')}
                                </div>
                            </div>
                        </div>
                        <div className="equi-blocks bordered-block">
                            <div className="title">
                                <span>
                                    Top vehicles : km Travelled
                                    <IButton imgContent="maxdistance.jpg" />
                                </span>
                                    
                            </div>
                            <div className="months-container">
                                <div>DAY</div>
                                <div>WEEK</div>
                                <div>MONTH</div>
                            </div>
                            <div className="analytics-container overflow">
                                <div className="prevContainer">
                                    {this.renderTopVehicles('day')}
                                    
                                </div>
                                <div className="currentContainer">
                                {this.renderTopVehicles('week')}
                                </div>
                                <div className="nextContainer">
                                {this.renderTopVehicles('month')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="equi-blocks bordered-block">
                            <div className="title">
                                <span>
                                    Entire fleet -  km Travelled/Month
                                    <IButton imgContent="distancemonth_graph.png" />
                                </span>
                                <div className="graphLegend">
                                    <div className="leg1">
                                        <div className="legLab"></div>
                                        <div className="legtext">{moment().subtract(1, 'years').format("YYYY")}</div>
                                    </div>
                                    <div className="leg2">
                                        <div className="legLab"></div>
                                        <div className="legtext">{moment().format("YYYY")}</div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="chartContainer">
                                <BarChart selectedBar={(this.state.selectedTime).toString()} actionOnClick={this.updateSelectedTime} chartData={this.state.entireFleetChartData} xDataType="date" />
                            </div>
                        </div>
                        <div className="equi-blocks bordered-block">
                            <div className="title">
                                <span>
                                    {(this.state.selectedDistanceType).split("_")[0]} km Travelled / models in {moment(this.state.selectedTime).format('MMM')}
                                    <IButton imgContent="distancemodel_graph.png" />
                                </span>
                                
                            </div>
                            <div className="chartContainer">
                                <BarChart selectedBar={this.state.selectedModel} actionOnClick={this.buildAvgDistanceOfSelectedModel} chartData={this.state.avgDistancePerModalInMonthChartData} xDataType="string" />
                            </div>
                        </div>
                        <div className="equi-blocks bordered-block">
                            <div className="title">
                                <span>
                                    {(this.state.selectedDistanceType).split("_")[0]} km travelled by {this.state.selectedModel}
                                    <IButton imgContent="distancemonth_graph.png" />
                                </span>
                                <div className="graphLegend">
                                    <div className="leg1">
                                        <div className="legLab"></div>
                                        <div className="legtext">{moment().subtract(1, 'years').format("YYYY")}</div>
                                    </div>
                                    <div className="leg2">
                                        <div className="legLab"></div>
                                        <div className="legtext">{moment().format("YYYY")}</div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="chartContainer">
                                <BarChart chartData={this.state.avgDistanceOfSelectedModel} xDataType="date" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderLoader()}
                {this.state.busy ? <div className='arLoader'><div className="loader"></div></div> : null}
                {this.state.nodata ? <div className='arLoader'>NO DATA</div> : null}
            </div>
        )
    }
}

export default DistanceReport;